import { render, staticRenderFns } from "./TrekLoading.vue?vue&type=template&id=b8179ef2&scoped=true&"
import script from "./TrekLoading.vue?vue&type=script&lang=js&"
export * from "./TrekLoading.vue?vue&type=script&lang=js&"
import style0 from "./TrekLoading.vue?vue&type=style&index=0&id=b8179ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8179ef2",
  null
  
)

export default component.exports